<fin-booking-plain-header-area [title]="'MMB.purchase.success.title' | finLocalization"></fin-booking-plain-header-area>

<div *ngIf="(orderStatus$ | async) === OrderStatus.OK; else loadError">
  <fin-section-review
    data-testid="mmb-purchase-introduction-note"
    class="mr-xsmall-t"
    [title]="'MMB.purchase.success.introductionMessage.title' | finLocalization"
    [noButton]="true"
  >
    <ng-container ngProjectAs="content">
      <div
        class="ps-xsmall-b"
        [innerHTML]="
          'MMB.purchase.success.introductionMessage.p1'
            | finLocalization: { emails: passengerEmails$ | async }
            | finSafe: 'html'
        "
      ></div>
      <p>{{ 'MMB.purchase.success.introductionMessage.p2' | finLocalization }}</p>
    </ng-container>
  </fin-section-review>

  <fin-included-products
    class="block mr-xsmall-t"
    [booking]="order$ | async"
    [useCabinClass]="false"
    [titleTranslationKey]="'MMB.purchase.success.purchaseTravelExtras'"
    [showAdditionalTitle]="true"
    [expandOpen]="true"
    [servicesToShow]="services$ | async"
    [displaySeatReassignMessage]="true"
  ></fin-included-products>

  <fin-section-review
    class="mr-xsmall-t"
    [fullWidth]="true"
    [title]="'purchase.review.priceBreakdown' | finLocalization"
    [noButton]="true"
  >
    <ng-container ngProjectAs="content">
      <div
        data-testid="mmb-purchase-success-points-notification"
        class="pr-small-x pr-small-t fill"
        *ngIf="(pointsUsedToPay$ | async) === true"
      >
        <fcom-notification>
          {{ 'purchase.success.pointsUsedToPay' | finLocalization }}
        </fcom-notification>
      </div>
      <fin-price-breakdown
        class="flex--basis-full"
        [prices$]="prices$"
        [passengers$]="order$ | finMap: 'passengers'"
        [showBaseFare]="false"
        [showTotalTax]="false"
        [expandOpen]="true"
      >
      </fin-price-breakdown>
    </ng-container>
  </fin-section-review>

  <fin-grand-total [prices$]="prices$" [serviceFlow$]="order$ | finMap: 'serviceFlow'"></fin-grand-total>

  <ng-container *ngIf="paymentMethods$ | async as paymentMethods">
    <fin-section-review class="mr-xsmall-t" [title]="'payment.paymentMethod.title' | finLocalization" [noButton]="true">
      <ng-container ngProjectAs="content">
        <fin-payment-method
          *ngFor="let paymentMethod of paymentMethods"
          [payment]="paymentMethod"
          class="flex--basis-full"
        />
      </ng-container>
    </fin-section-review>
  </ng-container>

  <fin-cartrawler-widget
    *ngIf="showCarTrawlerWidget$ | async"
    [clientId]="carTrawlerClientId"
    [order]="order$ | async"
    extraClasses="mr-xsmall-y"
  ></fin-cartrawler-widget>

  <fin-section-review
    data-testid="mmb-purchase-success-feedback"
    class="mr-xsmall-t"
    [title]="'MMB.purchase.success.feedback.title' | finLocalization"
    [noButton]="true"
  >
    <ng-container ngProjectAs="content">
      <fcom-button
        [text]="'MMB.purchase.success.feedback.button' | finLocalization"
        (clickBtn)="openModal($event)"
      ></fcom-button>
      <fin-qualtrics [survey]="survey" [(open)]="openSurvey"> </fin-qualtrics>
    </ng-container>
  </fin-section-review>
</div>

<ng-template #loadError>
  <fin-bound-selection-error-message
    (ctaClick)="loadOrderErrorClick.emit(true)"
    [ctaButtonText]="'bookingSearch.tryAgain' | finLocalization"
  >
    <span class="title">{{ 'serverErrorCodes.loadOrderFailed' | finLocalization }}</span>
  </fin-bound-selection-error-message>
</ng-template>

<div class="mr-small-y align-center">
  <fin-link [url]="ctaUrl" [text]="'MMB.purchase.success.cta' | finLocalization"></fin-link>
</div>
